import axios from "axios";
import posthog from "posthog-js";
import Cookies from 'js-cookie';
import { config } from "../config";

export const ndeFormInstance = axios.create({
  baseURL: "https://5370h1xoa0.execute-api.ap-south-1.amazonaws.com/default",
});

// Add a request interceptor
ndeFormInstance.interceptors.request.use(
  function (c) {
    try {
      c.data.utm_source = sessionStorage.getItem("utm_source")
        ? JSON.parse(sessionStorage.getItem("utm_source"))
        : {};

    if (sessionStorage.getItem("blog_banner")) {
      c.data.utm_source.banner = JSON.parse(
        sessionStorage.getItem("blog_banner")
      );
    }

    const analyticData = Cookies.get(config.analytics_cookie) ? JSON.parse(Cookies.get(config.analytics_cookie)) : {};

    c.data.utm_source = {
      ...c.data.utm_source,
      ...analyticData,
      sessionEndTime: new Date().toISOString(),
      sessionDuration: new Date() - new Date(analyticData.sessionStarted)
    };

    //  Track form ID under analytics
    if (c.data.form_id) {
      c.data.utm_source.form_id = c.data.form_id;
      delete c.data.form_id;
    }

    //  Get Page URL
    c.data.utm_source.currentPage = window.location.href;

    c.data.utm_source = JSON.stringify(c.data.utm_source);

    sessionStorage.setItem("userEngagementFormDisabled", "true");
    sessionStorage.setItem("calendly_data", JSON.stringify(c.data));
    } catch (e) {
      console.log(e);
    }

    return c;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
ndeFormInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    
    if (response.status === 200) {
      const distinctId = response.data?.data; 
      if (distinctId && typeof distinctId === 'string') {
        console.log('Identifying user with PostHog:', distinctId);
        
        posthog.identify(distinctId, {
          db_row_id: distinctId
        });
        
      } else {
        console.warn('Invalid distinct ID in response:', distinctId);
      }
    } else {
      console.warn('Response status is not 200:', response.status);
    }
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
